import { useEffect, useState, useCallback } from "react";
import { ShieldCheck } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import api from "../lib/api";
import { fmt, fmtCompact } from "../lib/format";

export default function TopListPanel({
  dsId, title, subtitle = "berdasarkan Total Tagihan", dimension, measure,
  extraFilters = [], filters = [], limit = 10, color = "#1C4A37", testid = "top-list-panel",
  month, monthColumn,
}) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/datasources/${dsId}/query`, {
        dimension, measure, aggregation: "sum", filters: [...filters, ...extraFilters], limit,
        month: monthColumn ? month : null, month_column: monthColumn,
      });
      setRows(data.data || []);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dsId, dimension, measure, JSON.stringify(extraFilters), JSON.stringify(filters), limit, month, monthColumn]);

  useEffect(() => { load(); }, [load]);

  const max = rows.length ? Math.max(...rows.map((r) => r.value)) : 0;

  return (
    <div className="rounded-2xl bg-card p-4 h-full flex flex-col shadow-sm ring-1 ring-black/[0.03]" data-testid={testid}>
      <div className="flex items-center gap-2">
        <span className="w-8 h-8 rounded-xl bg-accent flex items-center justify-center">
          <ShieldCheck size={17} weight="fill" className="text-primary" />
        </span>
        <div>
          <h3 className="font-display font-bold text-base leading-tight">{title}</h3>
          <p className="text-xs text-muted-foreground">{subtitle}</p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto mt-4 pr-1 space-y-3">
        {loading ? (
          <p className="text-xs text-muted-foreground animate-pulse">Memuat…</p>
        ) : rows.length === 0 ? (
          <p className="text-xs text-muted-foreground">Tidak ada data</p>
        ) : rows.map((r, i) => (
          <motion.div key={i} initial={{ opacity: 0, x: 8 }} animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.03 }} data-testid={`${testid}-row-${i}`}>
            <div className="flex items-center justify-between gap-2 text-xs mb-1">
              <span className="truncate flex items-center gap-2">
                <span className="w-5 h-5 rounded-md bg-secondary text-[10px] font-bold flex items-center justify-center shrink-0 tabular">{i + 1}</span>
                <span className="truncate" title={r.name}>{r.name}</span>
              </span>
              <span className="tabular font-bold shrink-0" title={fmt(r.value)}>{fmtCompact(r.value)}</span>
            </div>
            <div className="h-1.5 rounded-full bg-secondary overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${max ? (r.value / max) * 100 : 0}%`, background: color }} />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
